import { DateRange, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Grid, InputAdornment, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import $carbon from "../../../services/$carbon";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import moment from "moment";



function ResiduesForm(props) {
  const { model, setModel, nextStep, prevStep, climateZone, year, area } = props;


  const isValid = () => {
    return true;
  }

  useEffect(() => {
    if (model.management === 'burned') {
      if (model.amountBurned !== undefined) {
        let total = $carbon.calculateResideEmission(model.management, model.amountBurned, model.amountLeft, model.amountN, climateZone, area)
        console.log(total);

        setModel({ totalEmission: total });
      } else {
        setModel({ totalEmission: undefined })
      }
    } else {
      if (model.amountLeft !== undefined && model.amountN !== undefined) {
        let total = $carbon.calculateResideEmission(model.management, model.amountBurned, model.amountLeft, model.amountN, climateZone, area)
        console.log(total);

        setModel({ totalEmission: total });
      } else {
        setModel({ totalEmission: undefined })
      }
    }
  }, [model.management, model.amountBurned, model.amountLeft, model.amountN]);

  const renderLeftOnField = () => {
    return (
      <>

        <Grid item xs={12} sm={8}>
          <TextField size="small" value={model.amountLeft} onChange={(e) => setModel({ amountLeft: e.target.value })} type="number" label="Amount of residues left on the field (kg/ha)" variant="outlined" fullWidth />
        </Grid>
        {/* <Grid item xs={12} sm={8}>
          <Stack>
            <span>Nitrogen percentage in residues (%)</span>
            <Slider value={model.amountN} min={0} max={100} valueLabelDisplay="on" onChange={(evt, val) => setModel({ amountN: val })} />
          </Stack>
        </Grid> */}

      </>
    )
  }

  const renderBurned = () => {
    return (
      <>
        <Grid item xs={12} sm={8}>
          <TextField size="small" value={model.amountBurned} onChange={(e) => setModel({ amountBurned: e.target.value })} type="number" label="Amount of residues burned (kg/ha)" variant="outlined" fullWidth />
        </Grid>
      </>
    )
  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ mb: '5px' }}>Resiudes Management:</Typography>
                <ButtonGroup orientation="horizontal">
                  <Button variant={model.management === 'burned' ? 'contained' : 'outlined'} onClick={() => setModel({ management: 'burned' })}>Burned</Button>
                  <Button variant={model.management === 'left' ? 'contained' : 'outlined'} onClick={() => setModel({ management: 'left' })}>Left on field</Button>
                </ButtonGroup>

              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    format="YYYY-MM-DD"
                    minDate={moment(`${year}-01-01`)}
                    maxDate={moment(`${year}-12-31`)}
                    slotProps={{
                      textField: {
                        label: 'Date',
                        variant: 'outlined',
                        fullWidth: true,
                        size: 'small',
                        InputProps: { endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer', mb: '3px' }}><DateRange fontSize="small" /></InputAdornment> }
                      }
                    }}
                    value={model.date ? moment(model.date) : undefined}
                    onChange={(newValue) => setModel({date: newValue.format('YYYY-MM-DD')})} />
                </LocalizationProvider>
              </Grid>

              {model.management === 'burned' && renderBurned()}
              {model.management === 'left' && renderLeftOnField()}

            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} disabled={!isValid()} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} disabled={!isValid()} variant="contained" endIcon={<KeyboardArrowRight />}>Next</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default ResiduesForm;